import React, { createContext, useContext, useEffect, useState } from 'react';
import { SimsPageFilters } from './sim/simsPage/utils';

export type SimsPageSearchContextType = {
  filters?: SimsPageFilters[];
  updateFilters: (filters: SimsPageFilters[]) => void;
};

export const SimsPageSearchContext = createContext<SimsPageSearchContextType>({
  filters: undefined,
  updateFilters: (_: SimsPageFilters[]) => {}
});

export function SimsPageSearchContextProvider({
  children,
  scopeKey
}: {
  children: React.ReactNode;
  scopeKey: string;
}) {
  const [filters, setFilters] = useState<SimsPageFilters[] | undefined>();

  useEffect(() => {
    setFilters(undefined);
  }, [scopeKey]);

  function updateFilters(filters: SimsPageFilters[]) {
    setFilters(filters);
  }

  return (
    <SimsPageSearchContext.Provider
      value={{
        filters,
        updateFilters
      }}
    >
      {children}
    </SimsPageSearchContext.Provider>
  );
}

export function useSimsPageSearchContext() {
  const context = useContext<SimsPageSearchContextType>(SimsPageSearchContext);
  if (!context) {
    console.warn(
      'SimsPageSearchContext context is undefined, please verify you are calling useSimsPageSearchContext() as child of a <SimsPageSearchContextProvider> component.'
    );
  }

  return context;
}
